export default function ProductRangeHero() {
  return (
    <section className="relative w-full pt-32 sm:pt-40 pb-20 sm:pb-28">
      <div className="absolute inset-0 bg-gradient-to-b from-cyan-500/5 via-transparent to-transparent"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
        <p className="text-cyan-400 text-sm sm:text-base tracking-[0.3em] uppercase mb-6 font-medium">
          Nexa Pods Product Range
        </p>
        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-thin text-white leading-tight tracking-tight">
          MODULAR PODS
          <br />
          BUILT FOR WHAT&rsquo;S NEXT
        </h1>
        <p className="mt-6 text-base sm:text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed">
          Explore four distinct series of modular living spaces — from luxury capsules and adventure cabins to smart offices and future-forward accommodation.
        </p>
      </div>
    </section>
  );
}